import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";

export interface CompoundRecord {
  id: number;
  user_name: string;
  user_mobile: string;
  compound_name: string;
  created_at: string;
  pocket_items_count: number;
  total_recycle_price: number;
}

export interface CompoundRecordInfo {
  compound_records: Array<CompoundRecord>;
  total_result: number;
}

@Module
export default class CompoundRecordModule extends VuexModule implements CompoundRecordInfo {
  compound_records = [] as Array<CompoundRecord>;
  total_result = 0;

  @Action
  [Actions.GET_COMPOUND_RECORDS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/compound_records", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_COMPOUND_RECORDS, data.compound_records);
          this.context.commit(Mutations.SET_COMPOUND_RECORDS_COUNT, data.total_result);
          resolve();
        })
        .catch(({ response }) => {
          reject();
        });
    });
  }

  @Mutation
  [Mutations.SET_COMPOUND_RECORDS](compound_records: Array<CompoundRecord>) {
    this.compound_records = compound_records;
  }

  @Mutation
  [Mutations.SET_COMPOUND_RECORDS_COUNT](total_result: number) {
    this.total_result = total_result;
  }

  get currentCompoundRecords() {
    return this.compound_records;
  }

  get currentCompoundRecordCount() {
    return this.total_result;
  }
} 